import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

const TabPanel = ({ id, children, value, index, ...other }) => (
  <div role="tabpanel" hidden={value !== index} {...other}>
    {value === index && children}
  </div>
);

export const SFTabs = ({
  items = [],
  value,
  handleChange,
  variant = "scrollable",
  scrollButtons = "auto",
  hideBorders = false,
  borderBottom = 2,
}) => (
  <Box
    sx={{
      ...(!hideBorders && {
        borderBottom: borderBottom,
        borderColor: "rgba(255,255,255,0.2)",
      }),
      mb: 2,
      mr: 2,
    }}
  >
    <Tabs
      value={value}
      onChange={(e, index) => handleChange(index)}
      variant={variant}
      scrollButtons={scrollButtons}
    >
      {items.map((item, index) => (
        <Tab
          key={`${item.label}-${index}`}
          value={item.id}
          label={item.label}
        />
      ))}
    </Tabs>
  </Box>
);

export const SFTabsVertical = ({
  items = [],
  value,
  handleChange,
  scrollable,
  className = null,
}) => (
  <Box
    sx={(theme) => ({
      width: "100%",
      pr: 2,
      ...(scrollable && {
        height: 0,
        flex: "1 0 auto",
        ...theme.scrollable,
      }),
      marginTop: "0 !important",
    })}
  >
    <Tabs
      orientation="vertical"
      value={value}
      onChange={(e, index) => handleChange(index)}
    >
      {items.map((item, index) => (
        <Tab
          key={`${item.label}-${index}`}
          value={item.id}
          label={item.label}
          className={className}
        />
      ))}
    </Tabs>
  </Box>
);

export const SFTabPanel = ({ value, index, children, className }) =>
  Array.isArray(children) ? (
    <>
      {children.map((item, i) => (
        <TabPanel key={i} className={className} value={value} index={index}>
          {item}
        </TabPanel>
      ))}
    </>
  ) : (
    <TabPanel className={className} value={value} index={index}>
      {children}
    </TabPanel>
  );
